import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
// import styles from '../styles/Critical.module.css'
import style from '../styles/Library.module.css'
import Loading from "../components/common/Loading";
import { activateCTStudent, initCT, pingCriticalThinking, resultCT, submitActivity } from "../resources/api";
import Day1 from "../components/days/Day1";
import Day2 from "../components/days/Day2";
import NextDay from "../components/days/NextDay";
import Day3 from "../components/days/Day3";
import Day4 from "../components/days/Day4";
import clsx from "clsx";
import { CorrectIcon, CTLessonIntro, WrongIcon } from "../resources/svgs";
import { formatTime } from "../utils/common";
import ProgressBar from "react-bootstrap/ProgressBar";
import useCountDown from "../utils/countdown";
import useStickyState from "../utils/stickyState";
import Button from "../components/common/Button";
import { useSoundManager } from "../utils/sound";
import FlipNumbers from "react-flip-numbers";
import wait, { delayAll } from "../utils/wait";
import UserContext from "../context/UserContext";
import Introduction from "../components/introduction/Introduction";
import CTGuidedPractice from "../components/common/CTGuidedPractice";
import SubmitContext from "../context/SubmitContext";
import { playSound } from "../utils/playsound";
import { InstructionMark, InstructionMarkDisabling } from "../utils/instruction";
import * as processingAnimation from "../lottie/processing.json";
import Lottie from "react-lottie";
import { useWindowSize } from "react-use";
import Modal from "../components/common/Modal";
import medal from "../lottie/medal.json"
import homebutton from "../lottie/homebutton.json"
import { NONE } from 'phaser';
import think from "../lottie/think.json"
import { getGradeLevel } from '../const/ct';
import { cn } from '../utils/utils';
import { getMsBg } from '../utils/style';
import { useNavigate } from 'react-router-dom';
var proceduralInterval;


var retrivePausedFunction, pauseTimeOut;
function HeaderComponent({ loadedData, gradeLevel, noLessonId = false }) {
    return <div style={{
        position: "sticky",
        top: 0,
        zIndex: 1400
    }}
    >
        <div style={{
            background: getMsBg(gradeLevel),
            height: '110px',
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
        }}
        >
            {!noLessonId && <div style={{
                fontSize: '48px',
                fontWeight: "bold",
                color: '#ececec',
                flex: '0 0 200px',
                fontFamily: "League Spartan",
                marginRight: '20px',
                marginLeft: '20px',
                whiteSpace: "nowrap"
            }}>
                Lesson {
                    Math.ceil(loadedData?.itemNumber / 4)
                }
            </div>}
            <div style={{
                flex: '1',
                display: 'flex',
                flexDirection: "column",
                alignItems: 'center',
                gap: 5
            }}>

                <h1 className={styles.headerContainer}>
                    {
                        loadedData.dayType == "day1" && "Vocabulary Builder"
                    }
                    {
                        loadedData.dayType == "day2" && "Vocabulary Review"
                    }
                    {
                        loadedData.dayType == "day3" && "Critical Thinking & Comprehension"
                    }
                    {
                        loadedData.dayType == "day4" && "Closing Practice"
                    }
                </h1>
                <div style={{ alignSelf: "stretch", display: "flex" }}>
                    <ProgressBar className={styles.progressBar}
                        now={Number.parseInt(loadedData?.dayType?.replace("day", "")) * 25}
                        label={
                            <span style={{
                                fontSize: '14px',
                                fontWeight: "bold",
                                color: "#000"
                            }}>Activity {
                                    loadedData?.dayType?.replace("day", "")
                                }</span>} animated variant="warning" striped={true} style={{
                                    flex: '1',
                                    height: '25px',
                                    borderRadius: '20px',
                                    width: '50%'
                                }} />

                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src="/read21-logo.png"
                    style={{ width: '192px', height: '125px', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', marginTop: '10px', marginLeft: '15px' }} />
            </div>
        </div>

    </div>
}
function TimeOutPopup({ onClose }) {
    useEffect(() => {
        pauseTimeOut = setTimeout(() => {
            window.location.reload()
        }, 60 * 1000 * 3)
        return () => {
            clearTimeout(pauseTimeOut)
        }
    }, [])
    return <div className={styles.pausedPage}>
        <h1>Timed Out</h1>
        <Button noSoundCheck={true} processingLoader={false} onClick={async () => {
            clearTimeout(pauseTimeOut)
            onClose()
        }} icon={"nextarrow"} border={"white"} background={"green"} title={`Continue`} />
    </div>
}

const KidishText = ({ children }) => (
  <div className={style.kidishText}>
    {children}
  </div>
);
export default function LibraryIntro() {
     const {user} = useContext(UserContext);
   const navigate = useNavigate();

   const [isHovered, setIsHovered] = useState(false);
   
   const handleEnterLibrary = () => {
       console.log("Entering library...");
       navigate("/library");
    };
    
    return (
  
    <main className=" h-screen w-screen overflow-hidden flex flex-col items-center justify-center relative bg-[#78829b]">
      <img
        className="absolute inset-0 w-full h-full object-cover z-0"
        alt="Library background decoration"
        src="/library-outdoor.png"
      />

      {/* <img
        className="relative self-stretch w-full mt-[-1252px] object-cover"
        alt="Rachel Stolberg outside the front entrance to a large library"
        src="/library-outdoor.png"
      /> */}
       {/* Overlay for darkening or color effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-transparent z-10"></div>


      <section className="flex justify-center relative z-20 w-full h-full flex-col items-center">
        {/* <div className="inline-flex relative flex-[0_0_auto] flex-col items-center gap-[5px]"> */}
          {/* <img
            className="relative w-[210px] h-16 object-cover"
            alt="Library logo shapes"
            src={image}
          />

          <img
            className="relative w-[280px] h-[98px] object-cover"
            alt="3D decorative shapes"
            src={shapes3DImage}
          /> */}

         <div className="mb-8 md:mb-12 mt-20 md:mt-42 sm:mt-24 sm:mb-30">
          <KidishText>{user.firstName}&apos;s</KidishText>
          <KidishText>Library</KidishText>
        {/* </div> */}

        </div>
      

      <button
        className="inline-flex items-center justify-center px-12 md:px-16 py-4 md:py-8 gap-[30px] pl-[30px] pr-10 py-[30px] rounded-[20px] shadow-[inset_0px_-4px_15px_#3b6faa] bg-[linear-gradient(0deg,rgba(43,255,244,0)_0%,rgba(0,76,175,0.2)_100%),linear-gradient(0deg,rgba(73,162,245,1)_0%,rgba(73,162,245,1)_100%)] cursor-pointer transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-300 focus:ring-opacity-50 mt-38 md:mt-40"
        onClick={handleEnterLibrary}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Enter the library"
        type="button"
      >
        <span className="relative w-fit mt-[-1.00px] [text-shadow:1px_1px_1px_#ffffff] [-webkit-background-clip:text] bg-clip-text [-webkit-text-fill-color:transparent] [text-fill-color:transparent] [font-family:'Roboto-Bold',Helvetica] font-bold text-transparent text-[32px] text-center tracking-[0] leading-[normal] whitespace-nowrap">
          Enter Library
        </span>
      </button>
      </section>
    </main>
  );
};

